'use client';

import { useRouter } from 'next/navigation';
import type { PageName } from '@/constants/navigation.constants';
import TextButton from '@/shared/ui/atoms/TextButton';

interface NavigationDropdownItem {
  pageName: PageName;
  label: string;
}

interface NavigationDropdownProps {
  items: NavigationDropdownItem[];
  getNavigationItem: (pageName: PageName, appStoreId: number) => string;
  appStoreId: number;
  pathname: string;
}

const NavigationDropdown = ({ items, getNavigationItem, appStoreId, pathname }: NavigationDropdownProps) => {
  const router = useRouter();

  return (
    <ul className="absolute top-full left-0 p-[10px] bg-white rounded-[8px] shadow-[0_1px_10px_1px_rgba(19,19,19,0.15)] py-2 min-w-[200px] z-[100]">
      {items.map((item) => {
        const navigationPath = getNavigationItem(item.pageName, appStoreId);
        const isActive = pathname === navigationPath;

        return (
          <li key={item.pageName}>
            <TextButton
              label={item.label}
              onClick={() => {
                router.push(navigationPath);
              }}
              className={`py-[10px] px-[12px] text-start w-full text-[#333438] text-[16px] leading-[24px] rounded-[4px] transition-all hover:bg-[#F9FAFB] ${
                isActive ? 'font-semibold bg-[#F9FAFB]' : 'font-medium'
              }`}
            />
          </li>
        );
      })}
    </ul>
  );
};

export default NavigationDropdown;
